<template>
    <div class="row">
        <div class="col-md-12">
            <div class="mb-3">
                <label for="kt_platform" class="col-form-label">Platform</label>
                <select class="form-select" id="kt_platform" v-model="form.kt_platform" @change="changePlatform()">
                    <option  v-for="(serverPlatform, index) in serverPlatforms" :key="'kt_platform_'+index" :value="serverPlatform.label">
                        {{ serverPlatform.value }}
                    </option>
                </select>
                <v-errors :errors="errorFor('kt_platform')"></v-errors>
            </div>
            <div class="mb-3">
                <label for="cloud_server_id" class="col-form-label">Server</label>
                <select class="form-select" id="cloud_server_id" v-model="form.cloud_server_id">
                    <option  v-for="(cloudServer, index) in cloudServers" :key="'cloud_server_'+index" :value="cloudServer.id">
                        {{ cloudServer.server_name }}
                    </option>
                </select>
                <v-errors :errors="errorFor('cloud_server_id')"></v-errors>
            </div>
            <div class="mb-3">
                <label for="cloud_network_id" class="col-form-label">Network</label>
                <select class="form-select" id="cloud_network_id" v-model="form.cloud_network_id">
                    <option  v-for="(cloudNetwork, index) in cloudNetworks" :key="'cloud_network_'+index" :value="cloudNetwork.id">
                        {{ cloudNetwork.public_ip }}
                    </option>
                </select>
                <v-errors :errors="errorFor('cloud_network_id')"></v-errors>
            </div>
            <div class="form-check mb-3" v-if="form.kt_platform == 'g'">
                <input class="form-check-input" type="checkbox" id="portRange" v-model="form.port_range">
                <label class="form-check-label" for="portRange">
                    Set ports to a range
                </label>
            </div>
            <div class="row" v-if="form.port_range">
                <div class="col_3">
                    <div class="mb-3">
                        <label for="private_port_one" class="col-form-label">Private port one</label>
                        <input type="text" class="form-control" id="private_port_one" v-model="form.private_port_one">
                        <v-errors :errors="errorFor('private_port_one')"></v-errors>
                    </div>
                </div>
                <div class="col_3">
                    <div class="mb-3">
                        <label for="private_port_two" class="col-form-label">Private port two</label>
                        <input type="text" class="form-control" id="private_port_two" v-model="form.private_port_two">
                        <v-errors :errors="errorFor('private_port_two')"></v-errors>
                    </div>
                </div>
                <div class="col_3">
                    <div class="mb-3">
                        <label for="public_port_one" class="col-form-label">Public port one</label>
                        <input type="text" class="form-control" id="public_port_one" v-model="form.public_port_one">
                        <v-errors :errors="errorFor('public_port_one')"></v-errors>
                    </div>
                </div>
                <div class="col_3">
                    <div class="mb-3">
                        <label for="public_port_two" class="col-form-label">Public port two</label>
                        <input type="text" class="form-control" id="public_port_two" v-model="form.public_port_two">
                        <v-errors :errors="errorFor('public_port_two')"></v-errors>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col_6">
                    <div class="mb-3">
                        <label for="private_port_one" class="col-form-label">Private port one</label>
                        <input type="text" class="form-control" id="private_port_one" v-model="form.private_port_one">
                        <v-errors :errors="errorFor('private_port_one')"></v-errors>
                    </div>
                </div>
                <div class="col_6">
                    <div class="mb-3">
                        <label for="public_port_one" class="col-form-label">Public port one</label>
                        <input type="text" class="form-control" id="public_port_one" v-model="form.public_port_one">
                        <v-errors :errors="errorFor('public_port_one')"></v-errors>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label for="protocol" class="col-form-label">Network</label>
                <select class="form-select" id="protocol" v-model="form.protocol">
                    <option value="tcp">TCP</option>
                    <option value="udp">UDP</option>
                </select>
                <v-errors :errors="errorFor('protocol')"></v-errors>
            </div>
            <div class="form-check mb-3" v-if="form.kt_platform == 'g'">
                <input class="form-check-input" type="checkbox" id="firewallAccess" v-model="form.firewall_access">
                <label class="form-check-label" for="firewallAccess">
                    Allow access to all targets through the firewall.
                </label>
            </div>
            <div class="mb-3">
                <div class="d_flex_start">
                    <button type="button" class="btn btn-primary btn-md  width_100p mr_10" :disabled="lyLoading" @click.prevent="submit" v-if="form.kt_platform == 'g'">Submit</button>
                    <button type="button" class="btn btn-primary btn-md  width_100p mr_10" :disabled="lyLoading" @click.prevent="submitForDPlatform" v-else>Submit</button>
                    <button type="button" class="btn btn-danger btn-md  width_100p" @click.prevent="closeModal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import {mapGetters} from 'vuex';
      export default {
          name: 'port-forwarding-form',
          props: ['closeModal','loadData'],
          data(){
              return {
                lyLoading: false,
                form: {
                    kt_platform: 'g',
                    cloud_server_id: '',
                    cloud_network_id: '',
                    port_range: false,
                    private_port_one: '',
                    private_port_two: '',
                    public_port_one: '',
                    public_port_two: '',
                    firewall_access: true,
                    protocol: 'tcp',
                },
                cloudServers: [],
                cloudNetworks: [],
              }
          },
          computed: {
            ...mapGetters({
                customer: 'auth/getUserInfo',
                permissions: 'serverPermissions/getServicePermission'
            }),
            canDelete() {
                return !!(this.selectedPortForwarding && this.selectedPortForwarding.kt_job_type === null);
            },
            serverPlatforms(){
                if(this.customer.g_platform && this.customer.d_platform){
                    return [
                        {label: 'g', value: 'G'},
                        {label: 'd', value: 'D'},
                    ];
                }else if(this.customer.g_platform){
                    return [
                        {label: 'g', value: 'G'},
                    ];
                }else if(this.customer.d_platform){
                    return [
                        {label: 'd', value: 'D'},
                    ];
                }else{
                    return [
                        {label: 'g', value: 'G'},
                    ];
                }
            }
        },
          created() {
              this.loadCloudServers()
              this.loadCloudNetworks()
          },
          methods: {
            changePlatform(){
                this.loadCloudServers()
                this.loadCloudNetworks()
            },
            loadCloudServers() {
                this.axios.get('/platform-cloud-servers/'+this.form.kt_platform)
                .then(({data}) => {
                    this.cloudServers = data.data
                    if(this.cloudServers.length > 0){
                        this.form.cloud_server_id = this.cloudServers[0].id
                    }
                })
            },
            loadCloudNetworks() {
                this.axios.get('/platform-cloud-networks/'+this.form.kt_platform)
                .then(({data}) => {
                    this.cloudNetworks = data.data
                    if(this.cloudNetworks.length > 0){
                        this.form.cloud_network_id = this.cloudNetworks[0].id
                    }
                })
            },
            submit() {
                this.allErrors = null;
                this.lyLoading = true;

                this.form.port_range = this.form.port_range ? 1 : 0
                this.form.firewall_access = this.form.firewall_access ? 1 : 0
                
                this.axios.post('/port-forwardings', this.form)
                .then((response) => {
                    if(response.data.success){
                        this.showSuccessMsg(response.data.message);
                        this.closeModal()
                        this.loadData()
                    }else{
                        this.form.port_range = this.form.port_range == 1 ? true : false
                        this.form.firewall_access = this.form.firewall_access == 1 ? true : false
                        this.$swal({
                            text: response.data.message,
                            showCancelButton: false,
                            confirmButtonText: 'Close!',
                            confirmButtonColor: '#dd4b39',
                            reverseButtons: true
                        })
                    }
                })
                .catch((err) => {
                    this.form.port_range = this.form.port_range == 1 ? true : false
                    this.form.firewall_access = this.form.firewall_access == 1 ? true : false
                    this.allErrors = err.response.data.errors
                    this.showFailMsg(err.response.data.message);
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            },
            submitForDPlatform() {
                this.allErrors = null;
                this.lyLoading = true;
                
                this.axios.post('/create-kt-d-port-forwarding', this.form)
                .then((response) => {
                    if(response.data.success){
                        this.showSuccessMsg(response.data.message);
                        this.closeModal()
                        this.loadData()
                    }else{
                        this.$swal({
                            text: response.data.message,
                            showCancelButton: false,
                            confirmButtonText: 'Close!',
                            confirmButtonColor: '#dd4b39',
                            reverseButtons: true
                        })
                    }
                })
                .catch((err) => {
                    this.allErrors = err.response.data.errors
                    this.showFailMsg(err.response.data.message);
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            },
          }
      }
  </script>
  <style scoped>

  </style>
  